import http from "@/http/http-portal-api";
import ResponseData from "@/types/IResponseData";

class ApplicationService {
  getPageUrls(): Promise<ResponseData<{[key: string]: string}>> {
    return http.get("page/page-urls");
  }

  getPageTexts(): Promise<ResponseData<{[key: string]: string}>> {
    return http.get("page/page-texts");
  }
}

export default new ApplicationService();